import { FC, lazy } from 'react';

import { Practices } from '@/modules/practices';

export const PracticesPage: FC = () => <Practices />;

export const PracticesPageLazy = lazy(async () => {
    const { PracticesPage } = await import('./page');

    return { default: PracticesPage };
});
